export class FlagsLocalStrategy {
    /**
     * @param context Flags map configuration.
     */
    constructor(config) {
        this.flags = config.flags;
    }
    /**
     * Feature is enabled.
     * @param name Feature name.
     */
    isEnabled(name) {
        var _a;
        return (_a = this.flags[name]) !== null && _a !== void 0 ? _a : false;
    }
}
